<template>
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <div class="union-pay">
    <component
      :is="infoCom"
      :detail="detail"
    />
    <div class="info-form">
      <template v-if="isNeedSetTransfer">
        <mm-form
          class="transfer-form"
          layout="vertical"
        >
          <div
            class="form-tips"
            v-t="'union.payInfo'"
          />
          <mm-form-field :label="$t('union.payerPlaceholder')">
            <mm-input
              :placeholder="$t('union.payerPlaceholder')"
              v-model="payer"
            />
          </mm-form-field>
          <mm-form-field :label="$t('union.payAccount')">
            <mm-input
              :placeholder="$t('union.payAccountPlaceholder')"
              v-model="account"
            />
          </mm-form-field>
          <mm-form-field :label="$t('union.amountList')">
            <upload-file
              multiple
              class="form-upload"
              @onChange="handleUpload"
            />
          </mm-form-field>
          <div class="form-action">
            <mm-button
              @click="handleSaveOrderTransfer"
              class="form-submit"
              type="primary"
            >
              {{ $t('message.submit') }}
            </mm-button>
          </div>
        </mm-form>
      </template>
      <div
        v-else
        class="union-tips"
      >
        <div v-t="'union.tips'" />
        <div>{{ $t('union.tipsInfo') }}400-0666-517</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import OrderApi from '@api/order'
  import UploadFile from '@components/UploadFile'
  import { PAY_TYPE_UNION, PAY_TYPE_UNION_DOLLAR } from '@utils/constants'
  import UnionInfoCn from './UnionInfoCn'
  import UnionInfoEn from './UnionInfoEn'
  import UnionInfoGoogleAndMarket from './UnionInfoGoogleAndMarket'

  export default {
    name: 'OrderPayUnion',
    props: {
      mold: {
        type: String,
        default: PAY_TYPE_UNION
      },
      isGoogleOrMarket:{
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        payer: '',
        account: '',
        amountList: ''
      }
    },
    computed: {
      ...mapState('order', {
        orderId: state => state.orderId,
        detail: state => state.detail
      }),
      infoCom() {
        if (this.mold == PAY_TYPE_UNION && this.isGoogleOrMarket) {
          return UnionInfoGoogleAndMarket;
        } else if (this.mold == PAY_TYPE_UNION) {
          return UnionInfoCn;
        } else if (
          this.mold == PAY_TYPE_UNION_DOLLAR &&
          !this.isGoogleOrMarket
        ) {
          return UnionInfoEn;
        }
        return ""
      },
      isNeedSetTransfer () {
        const isEmpty = transfer => {
          if (!transfer) return true
          return Object.values(this.detail.transfer).length < 1
        }
        return isEmpty(this.detail.transfer)
      }
    },
    methods: {
      ...mapActions('order', ['fetchOrderDetail']),
      async handleSaveOrderTransfer () {
        try {
          if (!this.payer) throw new Error(this.$t('union.payerError'))
          if (!this.account) throw new Error(this.$t('union.payAccountError'))
          if (!this.amountList) throw new Error(this.$t('union.amountListError'))
          await OrderApi.saveOrderTransfer({
            order_id: this.orderId,
            payer: this.payer,
            account: this.account,
            amount_list: this.amountList
          })
          this.fetchOrderDetail()
        } catch (error) {
          this.$message.error(error.message)
        }
      },
      handleUpload (files) {
        if (files.length < 1) return this.amountList = ''
        const amountList = files.map(file => ({
          file_name: file.name,
          url: file.url
        }))
        this.amountList = JSON.stringify(amountList)
      }
    },
    components: {
      UploadFile
    }
  }
</script>
<style lang="scss" scoped>
  .union-pay{
    display: flex;
    flex-direction: column;
  }
  .info-box{
    display: flex;
    flex-direction: column;
    padding: 20px 0 10px;
  }
  .info-box-en {
    .info-label{
      flex-basis: 135px;
    }
  }
  .info-item{
    display: flex;
    padding-bottom: 10px;
    align-items: flex-start;
  }
  .info-label{
    flex: 0 0 105px;
    color: #909090;
  }
  .info-value{
    font-weight: 600;
    color: #2A2A2A;
  }
  .transfer-form{
    position: relative;
    padding: 20px 20px 24px;
    font-size: 12px;
    background: #F5F5F5;
    .mm-form-field{
      width: 420px;
      @include layout--mobile{
        width: 100%;
      }
    }
  }
  .form-action{
    margin-top: -25px;
    overflow: hidden;
    @include layout--mobile{
      margin-top: 0;
    }
  }
  .form-submit{
    float: right;
  }
  .union-tips{
    font-size: 14px;
    line-height: 26px;
    color: #2A2A2A;
  }
</style>


